/**
 * Enumeration of all react-query keys availbale in our app.
 */
export const queryKeys = {
  // Global
  fonts: 'Fonts',
  popularFonts: 'Popular Fonts',
  allFonts: 'All Fonts',

  // User
  recentApps: 'Recent Apps',
  user: {
    teams: 'user-teams',
    notificationList: 'notification-list',
    trash: 'trash',
  },

  // Orgs
  orgs: 'Orgs',
  orgsPerms: 'Orgs Perms',

  // Org
  org: 'Org',
  orgApps: 'Org Apps',
  orgDatabases: 'Org Databases',
  orgMembers: 'Org Members',
  orgStorage: 'Org Storage',
  orgStorageFolders: 'Org Storage Folders',
  orgStorageMetrics: 'Org Storage Metrics',
  orgBrandKits: 'Org Brand Kits',
  orgBrandKitDetail: 'Org Brand Kit Detail',
  orgBrandkitApps: 'Org Brand Kit Apps',
  orgTeams: 'Org Teams',
  orgACL: 'Org ACL',
  orgPaymentMethodList: 'Org Payment Method List',
  orgBillingAddressList: 'Org Billing Address List',

  // Project
  projectDetail: 'Project Detail',

  // =========== V2 Only ====================

  // Org
  orgBrandKitsV2: 'Org Brand Kits V2',
  orgBrandKitDetailV2: 'Org Brand Kit Detail V2',

  // Grid DB
  Database: 'Database',
  Tables: 'Tables',
  TableData: 'TableData',
  gridTableData: 'Grid Table Data',

  // Builder
  appGlobalVariables: 'App Global Variables',
  appVersionHistory: 'App Version History',
  appBuilderDetail: 'App Builder Detail',
  compTableData: 'Comp Table Data',
  workerDataCache: 'Worker Data Cache',
  compSingleRowData: 'Comp Single Row Data',

  // Plugin
  pluginList: 'Plugin List',
  pluginForm: 'Plugin Form',

  // ...add more stuff here
} as const
